module.exports = __webpack_public_path__ + "img/step3.994de8fa.png";